/**
 * AvisoLeiturasPendentes — "N leitura(s) obrigatória(s) pendente(s)" (PR 5).
 *
 * O mesmo aviso âmbar que a Central de hoje mostra acima do feed; aqui recebe
 * a quantidade pronta (a página busca em `/portal/central/pending-reads`).
 * Com zero, não renderiza nada — aviso vazio é ruído.
 *
 * Âmbar é a cor que o portal já usa para "pendência" (Dashboard, Central):
 * verde diria "feito", e isto é o contrário.
 */
import { AlertTriangle } from "lucide-react";

export interface AvisoLeiturasPendentesProps {
  quantidade: number;
}

export function AvisoLeiturasPendentes({ quantidade }: AvisoLeiturasPendentesProps) {
  if (!Number.isFinite(quantidade) || quantidade <= 0) return null;

  const texto =
    quantidade === 1
      ? "1 leitura obrigatória pendente"
      : `${quantidade} leituras obrigatórias pendentes`;

  return (
    <div
      role="status"
      data-testid="aviso-leituras-pendentes"
      className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50/80 p-4"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" aria-hidden="true" />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-amber-900">{texto}</p>
        <p className="text-sm text-amber-800">
          Confirme abaixo os itens marcados como leitura obrigatória.
        </p>
      </div>
    </div>
  );
}

export default AvisoLeiturasPendentes;
